import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SearchService } from '../search.service';
import { FirestoreService } from '../firestore-service.service';
import { Chunk, Post, Template } from '../container';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PromptcatalogpopupComponent } from '../promptcatalogpopup/promptcatalogpopup.component';
import { SharedModule } from '../shared/shared.module';
import { WaitingplaceholderComponent } from '../waitingplaceholder/waitingplaceholder.component';
import { GeminiService } from '../gemini.service';
import { SharedServiceService } from '../shared-service.service';
import { SafeHtmlPipe } from '../safe-html.pipe';
interface SourceDocument {
  key: string;
  name: string;
  url: string;
  ners: { type: string, content: string }[];
  coverImageURL: string;
  contentKey: string;
  contentType: string;
  type: string;
  projectKey: string;
  projectName: string;
  score: number;
  checked: boolean;
}

@Component({
    selector: 'app-ragchat',
    templateUrl: environment.site == "productly" ? "./ragchat.component.productly.html" : "./ragchat.component.wroolo.html",
    styleUrl: './ragchat.component.scss',
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      PromptcatalogpopupComponent,
      WaitingplaceholderComponent,
      SafeHtmlPipe
    ]
})
export class RagchatComponent {
  @Input() userId: string = ""
 // @Input() responseSourceDocuments: SourceDocument[] = []
  @Input() responseChunks: Chunk[] = []
  @Input() chatTitle: string = "Chat with retrieved content"
  @Input() dynamicSearch: boolean = false // if true, each time user sends a comment, the search is performed again
  @Input() modelKey: string = "gemini-2.5-flash"
  @Input() embeddingModel: string = "gemini-embedding-001"
  @Input() organizationKey: string = ""
  @Input() selectedTeamKey: string = ""
  @Input() selectedTeamName: string = ""
  @Input() teams: any[] = []
  @Input() templates: Template[] = []
  @Input() projectKey: string = ""
  @Input() projectName: string = ""
  @Input() skippedContentKeys: string[] = []
  @Input() site: string = "wroolo"
  @Input() doLoadChats: boolean = true
  @Input() useSearchGrounding: boolean = false
  @Input() useKnowledgeBase: boolean = true
  @Input() incominingChatComments: {"content": string, "isAI": boolean}[] = []
  @Input() submitHeader: string = "What do you want to know?"
  @Input() llmLimit: number = 300
  @Input() usePromptCompletion: boolean = true
  @Input() dialogKey: string = ""
  @Input() usePromptCatalog: boolean = true
  @Input() selectedContentKeys: string[] = []
  @Input() userQuery: string = ""
  @Input() showCloseButton: boolean = false
  @Input() additionalContent: string = ""
  @Output() sendCommentEvent = new EventEmitter<{comment: string, dialogKey: string}>()
  @Output() closeEvent = new EventEmitter<void>()

  selectedContent: Post[] = []
  userComment = ""
  chatComments: {"content": string, "isAI": boolean}[] = []
  isAIThinking = false
  maxDocumentsToCheck = 40
  responseVectors: {"id": string, "score": number, "value": number[]}[] = []
  isLoadingLabelVisible = false
  loaderMessage = "Please wait, AI is working hard for you..."
  aiThinkingMessage = "I am thinking..."
  chatKey = ""
  chats: any[] = []
  showChatHistory = true
  selectedChatKey = ""
  maxConsolidatedChatLength = 10000
  isPromptCatalogOpened = false
  personas: {name: string, key: string, description: string}[] = []
  shownPersonas: string[] = []
  isDataSourcesVisible = false
  standardPromptRemoved = false
  chatStyle = "<style>h1, h2, h3 {font-size: 1.2em; font-weight: 400; font-family: 'Poppins'; line-height: 1.4em; } h4, h5, h6 { font-size: 1em; font-weight: 400; font-family: 'Poppins'; line-height: 1.4em; }</style>"
  prompts: string[] = []

  constructor (private search: SearchService, private firestore: FirestoreService, private gemini: GeminiService, private service: SharedServiceService) {
    this.site = environment.site
  }

  ngAfterViewInit() {
    this.chatKey = this.firestore.generateUID("ragchat-")
    if (this.doLoadChats == true) {
      this.getChats()
      this.getPersonas()
      this.getPrompts()
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['incominingChatComments']) {
      this.chatComments = [...this.incominingChatComments]
    }
    if (changes['selectedContentKeys']) {
      this.getSelectedContentKeys().then(() => {
        this.setDynamicSearch()
      })
    }

    if (changes['userQuery']) {
      this.userQuery = changes['userQuery'].currentValue
      if (this.userQuery != undefined && this.userQuery != "" && this.userQuery != "false") {
        this.sendComment(this.userQuery)
      }
    }

    if (changes['dynamicSearch']) {
    }

  }

  async getSelectedContentKeys() {
    this.selectedContentKeys = await this.firestore.getSelectedContentKeys(this.organizationKey, this.projectKey, this.userId)
    return this.selectedContentKeys
  }

  setDynamicSearch() {
    if (this.selectedContentKeys.length == 0 ) {
      this.dynamicSearch = true
    }
  }

  async getChats() {
    await this.firestore.getChats(this.organizationKey).then(result => {
      this.chats.length = 0
      this.chats = result
      this.chats = this.chats.filter(chat => chat.userId == this.userId)
      this.chats.sort((a, b) => b.dateOfUpdate - a.dateOfUpdate)
    })
  }

  async getPersonas() {
    await this.firestore.getTags(this.organizationKey).then((result: any) => {
      let personas: {"name": string, "key": string, "description": string}[] = []
      result.docs.forEach((child: any) => {
        const teamKey = child.get("teamKey")
        if (teamKey == this.selectedTeamKey) {
          personas.push({"name": child.get("name"), "key": child.id, "description": child.get("description")})
        }
      })
      this.personas = personas
    })
  }

  showAllPersonas() {
    this.shownPersonas = []
  }

  filterByPersona(persona: string) {
    if (this.shownPersonas.includes(persona)) {
      this.shownPersonas = this.shownPersonas.filter(item => item !== persona)
    } else {
      this.shownPersonas.push(persona)
    }
  }

  async sendComment(comment: string) {
    let chunksCount = 0
    const maxChunksSize = 20000
    this.isAIThinking = true
    this.aiThinkingMessage = "Analysing your question..."
    if (comment.length > 1) {
      this.sendCommentEvent.emit({comment: comment, dialogKey: this.dialogKey})
      this.chatComments.push({"content": comment, "isAI": false})
      if (this.usePromptCompletion == true) {
        if (this.dynamicSearch == true && this.useKnowledgeBase == true) { // search knowledge base with every comment if dynamic search is enabled
          let consolidatedChat = this.chatComments.filter(item => item.isAI == false).map(item => item.content).join("\n\n") // send only human comments as part of prompt
          if (consolidatedChat.length > this.maxConsolidatedChatLength) {
            consolidatedChat = consolidatedChat.substring(consolidatedChat.length - this.maxConsolidatedChatLength) // keep only last 10000 characters
          }
          await this.searchChunks(consolidatedChat)
        }
        let prompt = ""
        this.chatComments.forEach(item => {
          let prefix = "Human says: \n\n"
          if (item.isAI == true) {
            prefix = "AI answers: \n\n"
          }
          prompt += prefix + item.content + "\n\n\n\n"
        })
        if (this.responseChunks.length > 0) { // if there are chunks from knowledge base then add them to prompt
          prompt += "\n\nWhen answering the above question asked by human take into account only the following passages of text\n"
          let chunkSize = 0
         for (let chunk of this.responseChunks) {
          chunkSize += chunk.chunk.length
            const tags = await this.firestore.getTagsByPostKey(this.organizationKey, chunk.documentKey).then((result: any) => { // TO TRZEBA W PRZYSLZOSCI ZOPTYMALIZOWAĆ, ABY TAGI BYLY PAMIĘTANE PRZY CHUNKACH
              return result
            })
            if (this.selectedContentKeys.length > 0 || this.dynamicSearch == true) {
              if (this.selectedContentKeys.includes(chunk.documentKey) || this.dynamicSearch == true) { // select only chunks form checked documents
                if (this.shownPersonas.length > 0) {
                  if (tags && tags.some((tag: any) => this.shownPersonas.includes(tag))) {
                    prompt += "\n\n"+chunk.chunk
                    chunksCount++
                  }
                } else {
                  prompt += "\n\n"+chunk.chunk
                  chunksCount++
                }
              }
            }  else { // if no documents are checked 
              if (this.shownPersonas.length > 0) {
                if (tags && tags.some((tag: any) => this.shownPersonas.includes(tag))) {
                  prompt += "\n\n"+chunk.chunk
                  chunksCount++
                }
              } else {
                prompt += "\n\n"+chunk.chunk
                chunksCount++
              }
            }
            if (chunkSize > maxChunksSize) {
              break
            }
          }
          if (this.additionalContent.length > 0) {
            prompt += "\n\n" + this.additionalContent
            chunksCount++
          }
          if (chunksCount > 0) {
            await this.getResponseFromLLM(prompt)
          } else {
            this.chatComments.push({"content": "I didn't find any relevant information in the knowledge base. Please specify your question more clearly.", "isAI": true})
            this.firestore.updateChat(this.organizationKey, this.userId, this.chatKey, this.chatComments)
            this.isAIThinking = false
          }
        } else if (this.useKnowledgeBase == true) {
          this.chatComments.push({"content": "I didn't find any relevant information in the knowledge base. Please specify your question more clearly.", "isAI": true})
          this.firestore.updateChat(this.organizationKey, this.userId, this.chatKey, this.chatComments)
          this.isAIThinking = false
        } else if (this.useKnowledgeBase == false) {
          await this.getResponseFromLLM(prompt)
        }
      }
    } else {
      this.firestore.showSnackBar("Type your comment first.")
    }
    this.isAIThinking = false
    this.userComment = ""
  }

  async getResponseFromLLM(prompt: string) {
    this.isAIThinking = true
    this.aiThinkingMessage = "Getting response from AI..."
    await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, prompt + "Format it in HTML tags <p>, <li>, <ul>, <ol>, <h3>, <h4>, <h5>, <table>, <tr>, <td>, <th> only, do not add styles to tags nor markdown", this.llmLimit, this.useSearchGrounding, "gemini-2.5-flash").then(result => {
      let response = result.responseText
      if (response.startsWith("AI:") ) { // clean response from AI prefix
        response = response.substring(3)
      } else if (response.startsWith("<p>AI:")) {
        response = "<p>" + response.substring(6)
      } else if (response.startsWith("AI answers:")) {
        response = response.substring(11)
      }
      this.chatComments.push({"content": response||"", "isAI": true})
      this.firestore.updateChat(this.organizationKey, this.userId, this.chatKey, this.chatComments)
    })
    this.isAIThinking = false
  }


  openPromptCatalog() {
    this.isPromptCatalogOpened = !this.isPromptCatalogOpened
  }

  onSelectedPrompt(prompt: string) {
    if (prompt.length > 0) {
      this.userComment = prompt
      this.sendComment(prompt)
    }
    this.isPromptCatalogOpened = false
  }

  clearComments() {
    this.chatComments.length = 0
    setTimeout(() => {
      const element = document.getElementById('aichatinput');
      if (element != null) {
        element.scrollIntoView()
      }
    }, 100)
    this.chatKey = this.firestore.generateUID("ragchat-")
    if (this.doLoadChats == true) {
      this.getChats()
    }
  }

  async searchChunks(embeddingPrompt: string) { // sends question about documents
    this.aiThinkingMessage = "Analysing your question..."
    if (embeddingPrompt.length > 2) {
      let chunk = [{"key": "000", "chunk": embeddingPrompt+" "}] // if I don't add space at the end it doesn't yield proper vector
      this.aiThinkingMessage = "Your question has been sent to knowledge base. Retrieving content..."
      this.isAIThinking = true
      this.aiThinkingMessage = "Getting embedding for your question..."
      const queryVector: number[] = await this.gemini.getGeminiEmbeddings(chunk).then((res => { // getting embedding vector for prompt typed by user
        if (res != undefined && res.length > 0) {
          const embedding = res[0].values
          return embedding
        } else {
          return []
        }
      }))
      this.aiThinkingMessage = "Searching for matching content..."
      const result = await this.search.queryVector(this.organizationKey, queryVector, ["post", "document"], this.maxDocumentsToCheck*5, this.dynamicSearch).then((result: any) => {
        return result
     }).catch(error => {
      alert("error: " + error)
       this.hideLoader()
      })

      this.aiThinkingMessage = "Found matching content..."
        if (this.isString(result) == true) { // if result is string this means that error message was returned instead of array of results or no results were found
        } else {
          this.responseChunks = result.responseChunks
        //  this.reduceSearchResultSize(this.maxDocumentsToCheck) // check by default only first 10 documents
        }

      if (this.responseChunks.length == 0 ) {
        this.dynamicSearch = true
      }
    }
    this.hideLoader()
  }

  copyToClipboard(text: string) {
    text = this.firestore.stripHTML(text)
    navigator.clipboard.writeText(text).then(() => {
      this.firestore.showSnackBar("Copied to clipboard")
    })
  }

  hideLoader() {
    this.isLoadingLabelVisible = false
    this.loaderMessage = "Please wait, AI is working hard for you..."
  }


  isString(variable: any): boolean {
    return typeof variable === "string";
  }

  deleteChat(chatKey: string) {
    this.firestore.deleteChat(this.organizationKey, this.userId, chatKey).then(() => {
      this.chats = this.chats.filter(chat => chat.chatKey != chatKey)
      this.selectedChatKey = ""
      this.firestore.showSnackBar("Chat has been deleted.")
    })

  }

  continueChat(chatKey: string) { // continue chat with selected chat
    this.selectedChatKey = chatKey
    this.chatKey = chatKey
    this.chatComments = this.chats.find(chat => chat.chatKey == chatKey)?.chatComments || []
  }

  onRemovePromptPopup(value: boolean) {
    this.standardPromptRemoved = value
  }

  getPrompts() {
    this.firestore.getStandardPrompts(this.organizationKey).then((prompts: string[]) => {
      this.prompts = prompts
    })
  }

  closeRagchat() {
    this.closeEvent.emit()
  }

}
